import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking, false = anon, object = admin
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("suzel_admin_token"));

  const authClient = useCallback(() => {
    const t = localStorage.getItem("suzel_admin_token");
    return axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL,
      headers: t ? { Authorization: `Bearer ${t}` } : {},
      withCredentials: true,
    });
  }, []);

  useEffect(() => {
    const t = localStorage.getItem("suzel_admin_token");
    if (!t) {
      setUser(false);
      return;
    }
    axios
      .get(`${API}/me`, { headers: { Authorization: `Bearer ${t}` }, withCredentials: true })
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("suzel_admin_token");
        setUser(false);
      });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await axios.post(
      `${API}/login`,
      { email, password },
      { withCredentials: true }
    );
    localStorage.setItem("suzel_admin_token", data.access_token);
    setToken(data.access_token);
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await axios.post(`${API}/logout`, {}, { withCredentials: true });
    } catch (e) {
      // ignore
    }
    localStorage.removeItem("suzel_admin_token");
    setToken(null);
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, login, logout, authClient }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
